import { render, staticRenderFns } from "./MenuModify.vue?vue&type=template&id=20b5ba79&scoped=true"
import script from "./MenuModify.vue?vue&type=script&lang=js"
export * from "./MenuModify.vue?vue&type=script&lang=js"
import style0 from "./MenuModify.vue?vue&type=style&index=0&id=20b5ba79&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5ba79",
  null
  
)

export default component.exports